import Landing from "../home/components/Landing";

const Home = () => {
  return (
    <div>
      <Landing />
    </div>
  );
};

export default Home;
